export const monthCalculater = (birthDate: string): number => {
  if (!birthDate || birthDate.length !== 8) return 0;

  const year = parseInt(birthDate.substring(0, 4));
  const month = parseInt(birthDate.substring(4, 6));
  const day = parseInt(birthDate.substring(6, 8));

  const today = new Date();
  const birthDateObj = new Date(year, month - 1, day); // month는 0부터 시작하므로 -1

  const monthDiff =
    (today.getFullYear() - birthDateObj.getFullYear()) * 12 +
    (today.getMonth() - birthDateObj.getMonth());

  // 일자까지 고려하여 정확한 개월 수 계산
  if (today.getDate() < birthDateObj.getDate()) {
    return monthDiff - 1;
  }

  return monthDiff;
};
